import React, { useState, useRef, createContext, useContext, useEffect, } from "react";
import SideBarRadioButtons from "./components/SideBarRadioButtons";
import MultiSelect from "./components/MultiSelect";
import ChartCommon from "./components/charts/ChartCommon";
import { DataDownloader } from "./components/DataDownloader";
import { AnimatePresence, motion } from "framer-motion";
import lineChartIcon from "../images/icons/line_graph.svg";
import barChartIcon from "../images/icons/graph.svg";
import mapIcon from "../images/icons/map.svg";
import { MapChart } from "./components/charts/MapChart";
import Header from "./components/Header";
export const PrintContext = createContext(null);
export const PageTypeContext = createContext(undefined);
export const usePageType = () => useContext(PageTypeContext);
export function ChartApp({ pageType, mainPageData, fileDownloadLink, }) {
    var _a, _b, _c, _d;
    // config management
    const printContentRef = useRef(null);
    const [chosenCategory, setChosenCategory] = useState({
        chosenCategoryId: (_a = mainPageData[0]) === null || _a === void 0 ? void 0 : _a.categoryId,
        chosenCategoryLabel: (_b = mainPageData[0]) === null || _b === void 0 ? void 0 : _b.category,
    });
    const [chosenValue, setChosenValue] = useState({
        chosenValueId: (_c = mainPageData[0]) === null || _c === void 0 ? void 0 : _c.values[0].id,
        chosenValueLabel: (_d = mainPageData[0]) === null || _d === void 0 ? void 0 : _d.values[0].value,
    });
    // multiselects management
    const [multiSelectData, setMultiSelectData] = useState([]);
    const [optionsSelected, setOptionsSelected] = useState();
    const [multiSelects, setMultiSelects] = useState({});
    const [resetMulti, setResetMulti] = useState(false);
    const [area, setArea] = useState({ value: "polska", label: "Polska" });
    const [isMultiArray, setIsMultiArray] = useState([false, true]);
    const [isFilterUpdate, setIsFilterUpdate] = useState(false);
    // chart management
    const isStacked = pageType === "economic_zite_data" ||
        pageType === "economic_pite_data" ||
        pageType === "social_data"
        ? false
        : true;
    const [selectedChart, setSelectedChart] = useState("bar-chart");
    // to set current filters according to the current category
    useEffect(() => {
        let mockDataCategory = mainPageData.find((element) => {
            if (element.categoryId === chosenCategory.chosenCategoryId) {
                return true;
            }
        });
        let currentSelectFilters = mockDataCategory === null || mockDataCategory === void 0 ? void 0 : mockDataCategory.filters;
        currentSelectFilters.forEach((filterGroup) => {
            filterGroup.values.sort((a, b) => a.key.localeCompare(b.key));
        });
        if (currentSelectFilters && multiSelectData.length === 0) {
            setMultiSelectData(currentSelectFilters);
        }
        else if (currentSelectFilters && multiSelectData.length != 0) {
            const filtersChanged = currentSelectFilters.length !== multiSelectData.length ||
                currentSelectFilters.some((filter, index) => {
                    const existingFilter = multiSelectData[index];
                    if (!existingFilter || filter.filterId !== existingFilter.filterId) {
                        return true;
                    }
                    return JSON.stringify(filter.values) !== JSON.stringify(existingFilter.values);
                });
            if (filtersChanged) {
                setIsFilterUpdate(!isFilterUpdate);
                setMultiSelectData(currentSelectFilters);
                setMultiSelects({});
                setOptionsSelected(undefined);
                setResetMulti(!resetMulti);
            }
        }
    }, [chosenCategory]);
    // to add handler to the changing choosen manu options
    const radioButtonClickHandle = (category, categoryId, value, valueId) => {
        setChosenValue({
            chosenValueId: valueId,
            chosenValueLabel: value,
        });
        // to change category state when it is changing
        if (chosenCategory.chosenCategoryId === categoryId) {
            return;
        }
        else {
            setChosenCategory({
                chosenCategoryId: categoryId,
                chosenCategoryLabel: category,
            });
            if (pageType === "social_data" && categoryId !== "wskazniki-dla-wojewodztw" && selectedChart === "map-chart") {
                setSelectedChart("bar-chart");
            }
        }
    };
    mainPageData.forEach((category) => {
        category.values.map((value) => {
            value.callback = radioButtonClickHandle;
            return value;
        });
    });
    // to choose the part of data according to the choosen category
    const mockDataCategory = mainPageData.find((category) => {
        if (chosenCategory) {
            return category.categoryId === chosenCategory.chosenCategoryId;
        }
        return category.categoryId === mainPageData[0].categoryId;
    });
    const processData = (config) => {
        return config.map((element) => {
            let valuesMap = element.values.map((e, index) => {
                let doesElemContainNoData = e.data.map((el) => {
                    if (Array.isArray(el.data)) {
                        return el.data.every((d) => d.value === null);
                    }
                    else {
                        let firstValue = el.firstValue !== null ? false : true;
                        let secondVal = el.secondValue && el.secondValue !== null ? false : true;
                        return firstValue === true && secondVal === true;
                    }
                });
                if (area.value === "polska") {
                    return Object.assign(Object.assign({}, e), { disabled: doesElemContainNoData[0] });
                }
                else if (area.value === "polska-wojewodztwa") {
                    return Object.assign(Object.assign({}, e), { disabled: doesElemContainNoData[1] });
                }
                else {
                    let f = doesElemContainNoData.every((elem) => elem === true);
                    if (f) {
                        return Object.assign(Object.assign({}, e), { disabled: true });
                    }
                    else {
                        return Object.assign(Object.assign({}, e), { disabled: false });
                    }
                }
            });
            let enableArray = [];
            let disableArray = [];
            let accident = [];
            let map = valuesMap.forEach((params) => {
                if (params.value === "Wypadkowa") {
                    accident.push(params);
                }
                else if (params.disabled === true) {
                    disableArray.push(params);
                }
                else {
                    enableArray.push(params);
                }
            });
            let sortEnable = enableArray.sort((e, b) => e.value.localeCompare(b.value));
            let sortDisable = disableArray.sort((e, b) => e.value.localeCompare(b.value));
            let finalArrayOfValues = sortEnable.concat(accident).concat(sortDisable);
            return Object.assign(Object.assign({}, element), { values: finalArrayOfValues });
        });
    };
    // Processing data
    const processedMultiRadioButtonsConfig = processData(mainPageData);
    // to set multi option and max items according to the view in social view
    useEffect(() => {
        var _a, _b;
        if (pageType === "social_data" && area.value === "polska") {
            setIsMultiArray([false, true]);
            setSelectedChart("bar-chart");
        }
        else if (pageType === "social_data" &&
            area.value === "polska-wojewodztwa") {
            setIsMultiArray([false, false]);
        }
        else {
            setIsMultiArray([true, true]);
        }
        // this sector is to delete when we have the rest of data for the poland voivodeships Leaks and Thermal
        setChosenValue({
            chosenValueId: (_a = processedMultiRadioButtonsConfig[0]) === null || _a === void 0 ? void 0 : _a.values[0].id,
            chosenValueLabel: (_b = processedMultiRadioButtonsConfig[0]) === null || _b === void 0 ? void 0 : _b.values[0].value,
        });
    }, [mainPageData, area]);
    const filteredMultiSelectData = multiSelectData.filter((filterGroup) => {
        if (pageType === "social_data" && chosenCategory.chosenCategoryId === "wskazniki-dla-polski") {
            return filterGroup.filterId !== "year";
        }
        return true;
    });
    const multiSelectColSize = 12 / filteredMultiSelectData.length;
    return (React.createElement("div", { className: "container my-5" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-3" },
                React.createElement(SideBarRadioButtons, { multiRadioButtonsConfig: processedMultiRadioButtonsConfig, chosenCategory: chosenCategory, chosenValue: chosenValue, pageType: pageType })),
            React.createElement("div", { className: "col-9" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", null,
                        React.createElement(Header, { chosenCategory: chosenCategory, chosenValue: chosenValue, mockDataCategory: mockDataCategory }))),
                filteredMultiSelectData.length > 0 && (React.createElement("div", { className: "row mb-4 mt-2" }, chosenCategory.chosenCategoryId &&
                    filteredMultiSelectData.map((filterGroup, index) => {
                        return (React.createElement("div", { className: `col-${multiSelectColSize}`, key: index },
                            React.createElement(MultiSelect, { id: filterGroup.filterId, options: filterGroup, setOptionsSelected: setOptionsSelected, multiSelects: multiSelects, setMultiSelects: setMultiSelects, resetMulti: resetMulti, setResetMulti: setResetMulti, isMulti: isMultiArray[index], setIsMultiArray: setIsMultiArray, area: area, setArea: setArea })));
                    }))),
                React.createElement("div", { className: "row mt-3" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "chartOptions" },
                            React.createElement("div", { className: "chartOptions__tab" },
                                React.createElement("input", { checked: selectedChart === "bar-chart" ? true : false, type: "radio", name: "radio", id: "bar-chart", onChange: () => setSelectedChart("bar-chart") }),
                                React.createElement("label", { htmlFor: "bar-chart" },
                                    React.createElement("img", { src: barChartIcon, alt: "Wykres s\u0142upkowy", className: "me-2" }),
                                    "Wykres s\u0142upkowy")),
                            pageType !== "social_data" && (React.createElement("div", { className: "chartOptions__tab" },
                                React.createElement("input", { checked: selectedChart === "line-chart" ? true : false, type: "radio", name: "radio", id: "line-chart", onChange: () => setSelectedChart("line-chart") }),
                                React.createElement("label", { htmlFor: "line-chart" },
                                    React.createElement("img", { src: lineChartIcon, alt: "Wykres liniowy", className: "me-2" }),
                                    "Wykres liniowy"))),
                            React.createElement(AnimatePresence, null, pageType === "social_data" &&
                                chosenCategory.chosenCategoryId === "wskazniki-dla-wojewodztw" && (React.createElement(motion.div, { className: "chartOptions__tab", key: "chartOptions__tab__map", initial: { opacity: 0 }, exit: { opacity: 0 }, animate: { opacity: 1 } },
                                React.createElement("input", { checked: selectedChart === "map-chart" ? true : false, type: "radio", name: "radio", id: "map-chart", onChange: () => setSelectedChart("map-chart") }),
                                React.createElement("label", { htmlFor: "map-chart" },
                                    React.createElement("img", { src: mapIcon, alt: "Wykres na mapie", className: "me-2" }),
                                    "Mapa"))))),
                        React.createElement("div", { className: "print-area" },
                            React.createElement(PrintContext.Provider, { value: printContentRef }, selectedChart !== "map-chart" ? (React.createElement(ChartCommon, { pageType: pageType, multiSelects: multiSelects, chosenCategory: chosenCategory, chosenValue: chosenValue, mockDataCategory: mockDataCategory, optionsSelected: optionsSelected, isStacked: isStacked, selectedChart: selectedChart, area: area })) : (React.createElement(MapChart, { chosenValue: chosenValue, mockDataCategory: mockDataCategory, multiSelects: multiSelects, selectedChart: selectedChart })))),
                        React.createElement(DataDownloader, { downloadLink: fileDownloadLink, printContentRef: printContentRef })))))));
}
